var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":_vm.bizBaseUrl}},[_c('img',{attrs:{"src":require("@/assets/logo_biglobe_biz.png"),"alt":"BIGLOBEbiz."}})])])}
var staticRenderFns = []

export { render, staticRenderFns }